const FaxList = () => import('@/views/faxes/FaxList.vue')

// Dynamic imports
const FaxView = () => import('@/views/faxes/FaxView.vue')

export const faxRoutes = [
  {
    path: '/faxes',
    name: 'Faxes',
    component: FaxList,
    meta: {
      requiresAuth: true,
      title: 'Faxes'
    }
  },
  {
    path: '/faxes/:id',
    name: 'ViewFax',
    component: FaxView,
    meta: {
      requiresAuth: true,
      title: 'Fax Details'
    }
  }
]
